import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { StationeryReturnEditView } from 'src/sections/stationery-return/view';

export default function StationeryReturnEditPage() {
  const params = useParams();

  const { id } = params;

  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title>Stationery Return Edit</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.UPDATE_STATIONERY_RETURN,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryReturnEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
